import { Injectable } from '@angular/core';
import { CatalogMeModel, HxCatalogService } from 'hx-services';

const NOBODY: CatalogMeModel = {admin: false, canEditCards: false, canCreateCards: false, cardRightsEnforced: false};

/** What the signed-in employee may do in the catalog (`GET /adm/catalog/me`): the screens hide the buttons the backend would refuse. Asked once per session. */
@Injectable({providedIn: 'root'})
export class CatalogMeService {
  private cached?: Promise<CatalogMeModel>;

  constructor(
    private catalog: HxCatalogService,
  ) {
  }

  me(): Promise<CatalogMeModel> {
    if (!this.cached) {
      this.cached = this.catalog.getMe().catch(() => {
        // a failed answer must not stay for the whole session: the next screen asks again, this one shows nothing editable
        this.cached = undefined;
        return NOBODY;
      });
    }
    return this.cached;
  }
}
